export enum Errors {
  loadingProducts = 'Unable to load products',
  loadingPhones = 'Unable to load phones',
  loadingTablets = 'Unable to load tablets',
  loadingAccessories = 'Unable to load accessories',
}
